module.exports = __webpack_public_path__ + "assets/img/586f0299ce59bbb2fe85d149cae33686.webp";